// extracted by mini-css-extract-plugin
module.exports = {"text":"text__2YaYO","select":"select__2gbVI"};